import React, { useCallback, useEffect, useState } from "react";

import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  Select,
  InputLabel,
} from "@mui/material";
import { useStyles } from "./style.js";
import SearchIcon from "@mui/icons-material/Search";
import CustomExpandMore from "../../../common/CustomExpandMore.js";
import avatar from "../../../assets/images/Faculty/placeholder.svg";
import useStaff from "../../../Hooks/staff.js";
import { LazyImage } from "../../../components/LazyImage/index.js";
import CustomPagination from "../../../common/Pagination/index.js";
import usePagination from "../../../common/usePagination/index.js";
import useAuthStore from "../../../Hooks/auth.js";

const ViewFacualty = () => {
  const {
    facultyData,
    facultySearchAction,
    getFacultyStatusConfirmedAction,
    getFacultyStatusDeletedAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useStaff();
  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(12);
  // const [offset, setOffset] = useState(0);
  const [query, setQuery] = useState("");
  const [state,setState]=useState({
    name: "",
    filter:"",
  })
  const [searchName,setSearchName]=useState("")
  const { institutionId } = useAuthStore();

  React.useEffect(() => {
    const abortController = new AbortController();
    if (state.filter == "") {
      console.log("query", query);
      facultySearchAction({
        data: {
          name: state.name,
          sortBy: "asc",
          orderBy: "created_at",
          limit: perPage,
          offset: offset,
          institutionId,
          status: state.filter,
          // institutionId
        },
        signal: abortController.signal,
      });
    }
    else if(state.filter === "Confirmed") {
      getFacultyStatusConfirmedAction({
        limit: perPage,
        offset: offset,
        name: state.name,
        institutionId
      });
    }
    else if (state.filter === "Deleted") {
      getFacultyStatusDeletedAction({
        limit: perPage,
        offset: offset,
        name: state.name,
        institutionId
      });
    }

    return () => {
      abortController.abort();
    };
  }, [state, perPage, offset,page]);

  const getFaculty = useCallback(
    (e) => {
      const abortController = new AbortController();
      // setQuery("");
      facultySearchAction({
        data: {
          name: e.target.value,
          sortBy: "asc",
          orderBy: "created_at",
          limit: perPage,
          offset: offset,
          status: query,
          institutionId
        },
        signal: abortController.signal,
      });

      return () => {
        abortController.abort();
      };
    },

    [perPage, offset]
  );

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    // setPage(1);
    // setOffset(0);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  // useEffect(() => {
  //   if (query === "Confirmed") {
  //     getFacultyStatusConfirmedAction({
  //       limit: PerPage,
  //       offset: offset,
  //       institutionId
  //     });
  //   }
  //   if (query === "Deleted") {
  //     getFacultyStatusDeletedAction({
  //       limit: PerPage,
  //       offset: offset,
  //       institutionId
  //     });
  //   }
  // }, [query, PerPage, offset]);

  const count = Math.ceil(
    facultyData?.totalNoOfRecord?.totalNoOfRecords / perPage
  );
  const _DATA = usePagination(facultyData?.facultySearchResult, perPage);

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      _DATA.jump(p);
    },
    [perPage, page]
  );

  const handleSearch=()=>{
    setState({
      name:searchName,
      filter:query,
    })
    // setPage(1);
    // setOffset(0);
    setOffsetAction(0)
    setPageAction(1)
  }
  //console.log("facultyData", facultyData);
  // //console.log("facultyData?.facultySearchResult", facultyData?.facultySearchResult);

  const classes = useStyles();
  return (
    <Stack className={classes.faculty}>
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            py: 2,
          }}
          className={classes.lend}
        >
          <Typography sx={{ marginRight: "8px", fontFamily: "inter" }}>
            Search
          </Typography>
          <TextField
            id="studentId"
            name="studentId"
            placeholder="Search"
            type={"text"}
            sx={{
              width: 240,
              marginLeft: "20px",
            }}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start" sx={{ cursor: "pointer" }}>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <Stack
          sx={{
            flexDirection: "row",
            marginLeft: "20px",
            alignItems: "center",
          }}
        >
          <Typography className={classes.label}>Filter</Typography>
          <Stack>
            <Select
              id="dept"
              name="dept"
              IconComponent={CustomExpandMore}
              defaultValue=""
              placeholder="Show All"
              displayEmpty
              sx={{
                width: 240,
                marginLeft: "20px",
              }}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            >
              <MenuItem value="">Show All</MenuItem>
              <MenuItem value="Confirmed">Active</MenuItem>
              <MenuItem value="Deleted">InActive</MenuItem>
            </Select>
          </Stack>
        </Stack>
        <Stack
         sx={{
          flexDirection: "row",
          marginLeft: "20px",
          alignItems: "center",
        }}
        >
          <Button
            type="submit"
            sx={{
              px: 1,
              py: 1,
              borderRadius: "50px",
              // minWidth: "186px !important",
            }}
            onClick={handleSearch}
            className={classes.search_btn}
          >
            Search
          </Button>
        </Stack>
        </Stack>
        <Box sx={{ width: "90%" }}>
          <Paper
            sx={{
              width: "100%",
              p: 4,
              borderRadius: "20px",
              filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
              boxShadow: "none",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                justifyContent: "start",
                rowGap: "30px",
                paddingLeft: "13px",
              }}
              gap={5}
            >
              {/* filter((data)=> data.status == query  ). */}
              {facultyData?.facultySearchResult?.length > 0
                ? facultyData?.facultySearchResult.map((_el, index) => {
                  return (
                    <Grid
                      item
                      key={index}
                      lg={2.5}
                      md={5}
                      sm={6}
                      xs={12}
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-evenly"
                      alignItems="center"
                      p={2}
                      sx={{
                        boxShadow: "0px 4px 14px rgb(0 0 0 / 8%)",
                        borderRadius: "22px",
                        aspectRatio: "3/2",
                      }}
                    >
                      <Stack
                        sx={{
                          marginBottom: "10px",
                          flexWrap: "wrap",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span title={_el.firstName} className={classes.facultyName}>
                          {_el.firstName}
                        </span>
                        <span className={classes.dept}>{_el.designation}</span>
                      </Stack>
                      <div className={classes.img_container}>
                        <LazyImage src={avatar} />
                      </div>
                    </Grid>
                  );
                })
                : "No data"}
            </Grid>
            {facultyData?.totalNoOfRecord?.totalNoOfRecords > 10 && (
              <CustomPagination
                count={count}
                page={page}
                onPageChange={handleChange}
                handlePage={handlePage}
                perPage={perPage}
                // options={[12, 24, 36]}
              />
            )}
          </Paper>
        </Box>
      </Stack>
      );
};

export default ViewFacualty;
